import { apiStatusError, fetchError } from '../errors';
import { API_RESOURCES } from 'FRONTEND/utils/routes';

export const formatResource = (rawResources) => {
  return rawResources;
};


export const getResources = async() => {
  try {
    const response = await fetch(`${API_RESOURCES}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }).then((data) => {
      apiStatusError({ response: data });
      return data.json();
    });

    return response;
  } catch (error) {
    throw fetchError({ error });
  }
};
